import { Toaster } from '@consigli/shadcn';
import { Outlet } from 'react-router';

import { BreadcrumbProvider, DynamicBreadcrumb } from '@/components';

import { Navbar } from './navbar';

export const Layout = () => {
  return (
    <BreadcrumbProvider>
      <div className="bg-white min-h-screen">
        <Navbar />
        <div className="px-20 pt-24 pb-10">
          <DynamicBreadcrumb />
          <Outlet />
        </div>
        <Toaster />
      </div>
    </BreadcrumbProvider>
  );
};
